import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/the-first-alliance/demo-humans-image.png';
import _imports_1 from '@/assets/the-first-alliance/crypto-hodlers-image.jpg';
import _imports_2 from '@/assets/the-first-alliance/crypto-hodlers-image@2x.jpg';
import _imports_3 from '@/assets/the-first-alliance/crypto-hodlers-image@3x.jpg';
import _imports_4 from '@/assets/the-first-alliance/8sian-image.png';

const _withScopeId = n => (_pushScopeId("data-v-2e2588a6"), n = n(), _popScopeId(), n);

const _hoisted_1 = _imports_2 + ' 1x, ' + _imports_3 + ' 2x';

const _hoisted_2 = {
  class: "alliance-wrapper"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("Partners");

const _hoisted_4 = {
  div: "",
  class: "block"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "block"
}, null, -1));

const _hoisted_6 = /*#__PURE__*/_createTextVNode("Demi-Human NFT");

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" This collection is a derivative of Demi-Human NFT. The collection, which was developed by Demiverse Studio and the InvestNFT team, aims to enhance multiple empowerments, such as NFT-insurance, NFT-forging, lottery, and CeFi offer while exploring the new form of NFT in Web3. ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("More");

const _hoisted_9 = {
  class: "block"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  srcset: _hoisted_1,
  alt: "block"
}, null, -1));

const _hoisted_11 = /*#__PURE__*/_createTextVNode("Crypto Hodlers");

const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Crypto Hodlers is an NFT-powered, community-driven media brand. We are building the whole universe around the collection, using comics, stories, minigames, and events. Join our community and let's build the Crypto Hodlers story together! ");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("More");

const _hoisted_14 = {
  class: "block"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "block"
}, null, -1));

const _hoisted_16 = /*#__PURE__*/_createTextVNode("8SIAN");

const _hoisted_17 = /*#__PURE__*/_createTextVNode(" The 8SIAN brand aims to represent Asia in the Web3 space whilst also empowering Asians to be proud of their heritage, culture and upbringing. We strive to share our experience of NFTs and educate individuals by giving them the knowledge they need to operate in this new and exciting space. ");

const _hoisted_18 = /*#__PURE__*/_createTextVNode("More");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_landing_title = _resolveComponent("landing-title");

  const _component_block_with_image = _resolveComponent("block-with-image");

  return _openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_landing_title, null, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_block_with_image, {
    url: "https://opensea.io/collection/demihuman ",
    imagePosition: "left"
  }, {
    image: _withCtx(() => [_hoisted_5]),
    title: _withCtx(() => [_hoisted_6]),
    content: _withCtx(() => [_hoisted_7]),
    button: _withCtx(() => [_hoisted_8]),
    _: 1
  })]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_block_with_image, {
    url: "https://opensea.io/collection/crypto-hodlers-nft",
    imagePosition: "left"
  }, {
    image: _withCtx(() => [_hoisted_10]),
    title: _withCtx(() => [_hoisted_11]),
    content: _withCtx(() => [_hoisted_12]),
    button: _withCtx(() => [_hoisted_13]),
    _: 1
  })]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_block_with_image, {
    url: "https://opensea.io/collection/8sian-main-collection",
    imagePosition: "left"
  }, {
    image: _withCtx(() => [_hoisted_15]),
    title: _withCtx(() => [_hoisted_16]),
    content: _withCtx(() => [_hoisted_17]),
    button: _withCtx(() => [_hoisted_18]),
    _: 1
  })])]);
}